export default __webpack_public_path__ + "static/media/wreckingball-icon.4ac35f9a.webp";